import React, { Component } from 'react';
import styled from 'styled-components';
import Pose from './Pose';
import './App.css';

const SelectionContainer = styled.div`
  margin: auto;
  width: 90%;
  padding-top: 10px;
  padding-bottom: 10px;
  display: grid;
  grid-template-columns: repeat(3, 12fr);
  grid-row-gap: 1rem;
`

class Selection extends Component {

  renderPoses = () => {
    const { poseIdentifiers, indexPath } = this.props;
    return poseIdentifiers.map((poseIdentifier, index) =>
    <Pose poseIdentifier={poseIdentifier} indexPath={indexPath} inModal={true} key={index}/>)
  }

  render() {

    return (

        <SelectionContainer>
          { this.renderPoses() }
        </SelectionContainer>

    );
  }

}

export default Selection;



// WEBPACK FOOTER //
// ./src/Selection.js